<template>
  <el-dialog
    :is-cancel-btn="false"
    :is-savel-btn="false"
    :visible.sync="show"
    :modal-append-to-body="false"
    height="400px"
    title="外调车运单导入"
    width="600px"
  >
    <div class="batchExport">
      <ul>
        <li>
          <span> 1.下载运单模板 </span>
          <i class="iconfont iconInvoice" />
          <h6>外调车运单导入.xlsx</h6>
          <el-button plain size="mini" @click="downloadTemplate"> 下载运单模版 </el-button>
          <a ref="downloadTemplate" :href="href" style="display: none" />
        </li>
        <p />
        <li>
          <span> 2.上传填好的文件 </span>
          <i class="iconfont iconInvoice" />
          <h6>外调车运单导入.xlsx</h6>
          <label>
            <nf-upload
              :add-event-upload="addEventUpload"
              :headers="headers"
              type="0"
              url="/rest/waybill/v2/saveSuccessImport"
              @onProgress="addOnProgress"
            >
              <div slot="content">
                <el-button size="mini" type="primary"> 导入外调车运单 </el-button>
              </div>
            </nf-upload>
          </label>
        </li>
      </ul>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'NfDownUpload',
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      href: '/rest/waybill/v2/exportExcelTemplate',
    };
  },
  methods: {
    addEventUpload(data) {
      this.$emit('addEventUpload', data);
    },
    // 下载
    downloadTemplate() {
      this.$emit('downloadTemplate', this.$refs.downloadTemplate);
    },
    // 文件上传
    addOnProgress() {
      this.$emit('onProgress');
    },
  },
  watch: {
    show(val) {
      if (val == false) {
        this.$emit('update:show', val);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.batchExport {
  ul {
    display: flex;

    li {
      list-style-type: none;
      flex: 1;
      text-align: center;
      display: flex;
      align-items: center;
      flex-direction: column;

      i {
        display: inline-block;
        font-size: 55px;
        line-height: 65px;
        font-weight: normal;
        margin: 40px 0 20px 0;
        color: #1890ff;
      }

      .el-button {
        min-width: 100px;
        margin-top: 20px;
      }

      div {
        height: 47px;
        line-height: 47px;
        display: flex;

        .ruleInput {
          width: 150px;
        }
      }

      h6 {
        font-size: 12px;
      }
    }

    p {
      width: 0.1px;
      height: 200px;
      background: rgb(207, 205, 205);
      overflow: hidden;
    }
  }
}
</style>
